import React from 'react'
import { SupplierConciliationDetailView } from './logic/SupplierConciliationDetailView'

export const SupplierConciliationEdit = () => {
  return <SupplierConciliationDetailView isReadOnly={false} />
}

